import * as React from "react";
import {IReadNewsResponse} from "../../core/api/post/response/ReadNewsResponse";

interface IProps {
    data: IReadNewsResponse;
}

interface IState {
    menuItem: {}
}

export class NewsGridItem extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            menuItem: {}
        }
    }

    public render() {
        return (
            <div className="blog-item">
                <h2 className="blog-item-title font-alt">
                    <a href={'/berita/' + this.props.data.slug}>
                        {this.props.data.title}
                    </a>
                </h2>
                <div className="blog-item-data">
                    <a href={'/berita/' + this.props.data.slug}> {this.props.data.dateTime}</a>
                    <span className="separator">&nbsp;</span>
                </div>
                <div className="blog-media">
                    <ul className="clearlist content-slider">
                        <li><img src={this.props.data.image} alt="image" /></li>
                    </ul>
                </div>
                <div className="blog-item-body">
                    <p>
                        {this.props.data.shortDescription}
                    </p>
                </div>
                <div className="blog-item-foot">
                    <a className="btn btn-mod btn-round btn-small" href={'/berita/' + this.props.data.slug}>
                        Baca Detail
                    </a>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/news/NewsGridItem.tsx